import { render } from "./PersonDetailsCard.vue?vue&type=template&id=2e1508b6"
import script from "./PersonDetailsCard.vue?vue&type=script&lang=js"
export * from "./PersonDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__